import { BRAND_LIST, CountryLanguageSwitcher, DistanceUnit } from 'typings'
import * as Typings from '../typings'

const LuxembourgLocale: Typings.LocaleType = {
  IS_EU: true,
  REGION: Typings.RegionGroupNames.OTHER,
  CODE: 'lu',
  LANGUAGE_CODE: 'en',

  LONG_NAME: 'Luxembourg',
  SHORT_NAME: 'lu',

  DISPLAY_NAME: 'Luxembourg (English)',
  DISPLAY_COUNTRY: 'Luxembourg (English)',

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 49.8143656,
    INITIAL_LONGITUDE: 5.4739646,
    INITIAL_ZOOM: 5,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  AREAS: {
    '1': 'Bertrange',
    '2': 'Contern',
    '3': 'Hesperange',
    '4': 'Luxembourg',
    '5': 'Niederanven',
    '6': 'Sandweiler',
    '7': 'Schuttrange',
    '8': 'Steinsel',
    '9': 'Strassen',
    '10': 'Walferdange',
    '11': 'Weiler-la-Tour',
  },

  HOME_PAGE_URL: 'https://www.uniqlo.com/eu-lu/en/',

  MAP_MOBILE_URL: 'https://map.uniqlo.com/eu-lu/en/',

  CONTACT_US_URL: 'https://faq-eu.uniqlo.com/',
  TERMS_OF_USE_URL:
    'https://faq-eu.uniqlo.com/pkb_Home_UQ_EU?l=en&c=category_uq_eu_dk_se%3ARenew_UQEU_C7_3',
  PRIVACY_POLICY_URL:
    'https://faq-eu.uniqlo.com/pkb_Home_UQ_EU?l=dk&c=category_uq_eu_dk_se%3ARenew_UQEU_C7_2',

  POSTCODE_FORMAT: /^[0-9]{4}$/,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },

  DISTANCE_UNIT: DistanceUnit.KM,

  SHOW_COUNTRY_LANGUAGE_MODAL: {
    [BRAND_LIST.UQ]: CountryLanguageSwitcher.HEADER_SWITCHER_MODAL,
    [BRAND_LIST.GU]: CountryLanguageSwitcher.ALL_DISABLED,
    [BRAND_LIST.PL]: CountryLanguageSwitcher.ALL_DISABLED,
  },

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
  },
}

export default LuxembourgLocale
